import { render } from "./CCrestartRecordList.vue?vue&type=template&id=0ac3a32f&scoped=true"
import script from "./CCrestartRecordList.vue?vue&type=script&lang=js"
export * from "./CCrestartRecordList.vue?vue&type=script&lang=js"

import "./CCrestartRecordList.vue?vue&type=style&index=0&id=0ac3a32f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0ac3a32f"

export default script